import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // 确保导入了 store
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 引入样式重置
import "./styles/index.css";

// 使用 ElementUI
Vue.use(ElementUI);

// 配置全局请求拦截器
import axios from "axios";

// axios 配置
axios.defaults.baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8011"
    : "https://www.utsall.com";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 这里可以添加 token 等认证信息
    const token = localStorage.getItem("user_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Vue.prototype.$message.error("未授权，请重新登录");
          router.push("/login");
          break;
        case 403:
          Vue.prototype.$message.error("拒绝访问");
          break;
        case 500:
          Vue.prototype.$message.error("服务器内部错误");
          break;
        default:
          Vue.prototype.$message.error("网络错误，请稍后重试");
      }
    } else {
      Vue.prototype.$message.error("网络连接失败");
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

// 挂载到 Vue 原型，方便组件内使用
Vue.prototype.$http = axios;

new Vue({
  router,
  store, // 确保在这里注入 store
  render: (h) => h(App),
}).$mount("#app");
